export default __webpack_public_path__ + "guide--vector-tiles-standards-ccw-480-c06b6fe69d6cf7abbfb8a849b78d2492.png";